'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _ButtonClear = require('../button/ButtonClear');

var _ButtonClear2 = _interopRequireDefault(_ButtonClear);

var _IconComponent = require('../icon/IconComponent');

var _IconComponent2 = _interopRequireDefault(_IconComponent);

var _language = require('../language');

var _UtilApi = require('../utils/UtilApi');

var _UtilLodash = require('../utils/UtilLodash');

require('./css/base.scss');

var _Placeholder = require('./Placeholder');

var _Placeholder2 = _interopRequireDefault(_Placeholder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BaseComponent = function (_React$PureComponent) {
  (0, _inherits3.default)(BaseComponent, _React$PureComponent);

  function BaseComponent(props) {
    (0, _classCallCheck3.default)(this, BaseComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (BaseComponent.__proto__ || (0, _getPrototypeOf2.default)(BaseComponent)).call(this, props));

    _this.onClear = function () {
      _this.setValue(null);
    };

    _this.handleBlur = function () {
      var onBlur = _this.props.onBlur;
      var value = _this.state.value;

      onBlur && onBlur(value);
    };

    _this.handleChange = function (value) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          readOnly = _this$props.readOnly;

      if (disabled || readOnly) {
        return;
      }
      _this.setValue(value);
    };

    _this.handleFocus = function (event) {
      _this.props.onFocus && _this.props.onFocus(event);
    };

    _this.renderCleavePhone = function () {};

    _this.state = {
      value: _this.convertValue(!_this.checkIsEmptyOrNull(props.value) ? props.value : props.defaultValue)
    };
    _this.ref = _react2.default.createRef();
    _this.getValue = _this.getValue.bind(_this);
    _this.setValue = _this.setValue.bind(_this);
    _this.dataTestID = 'base';
    return _this;
  }

  (0, _createClass3.default)(BaseComponent, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.compareValue(nextProps.value)) {
        this.setState({
          value: this.convertValue(nextProps.value)
        });
      }
    }
  }, {
    key: 'compareValue',
    value: function compareValue(nextValue) {
      var componentInField = this.props.componentInField;

      var valueState = this.state.value;
      if (this.isFile) {
        valueState = this.state.file;
      }
      if (componentInField) {
        if (this.checkIsEmptyOrNull(nextValue) && this.checkIsEmptyOrNull(valueState)) {
          return false;
        }
        return !_lodash2.default.isEqual(nextValue, valueState);
      }
      if (this.checkIsEmptyOrNull(nextValue) && this.checkIsEmptyOrNull(this.props.value)) {
        return false;
      }
      return !_lodash2.default.isEqual(nextValue, this.props.value);
    }
  }, {
    key: 'getRootProperty',
    value: function getRootProperty() {
      var rootProperty = this.props.rootProperty;

      var proxy = (0, _UtilApi.getProxy)(this.props);
      return _lodash2.default.get(proxy, rootProperty) || rootProperty;
    }
  }, {
    key: 'convertValue',
    value: function convertValue(value) {
      return value;
    }
  }, {
    key: 'compareOptions',
    value: function compareOptions(nextOptions, options) {
      var valueKey = this.props.valueKey;

      if (_lodash2.default.size(nextOptions) !== _lodash2.default.size(options)) {
        return true;
      }
      var nextIds = _lodash2.default.orderBy(_lodash2.default.map(nextOptions, function (nextOption) {
        return _lodash2.default.get(nextOption, valueKey);
      }));
      var ids = _lodash2.default.orderBy(_lodash2.default.map(options, function (option) {
        return _lodash2.default.get(option, valueKey);
      }));

      return !_lodash2.default.isEqual(nextIds, ids);
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      return this.state.value;
    }
  }, {
    key: 'setValue',
    value: function setValue(value, valueObject) {
      var onChange = this.props.onChange;

      this.setState({ value: value }, function () {
        onChange && onChange(value, valueObject);
      });
    }
  }, {
    key: 'onFocus',
    value: function onFocus() {
      this.ref.focus();
    }
  }, {
    key: 'checkIsEmptyOrNull',
    value: function checkIsEmptyOrNull(value) {
      return (0, _UtilLodash.checkIsEmpty)(value);
    }
  }, {
    key: 'getPlaceholder',
    value: function getPlaceholder(keyWord, placeholderDefault) {
      var placeholder = this.props.placeholder;

      if (placeholder === undefined || placeholder === null) {
        if (placeholderDefault) {
          return placeholderDefault;
        }
        return (0, _language.t)(keyWord) + '...';
      }
      return placeholder;
    }
  }, {
    key: 'tooglePlaceholder',
    value: function tooglePlaceholder(value) {
      if (value === undefined || value === null || value === "") {
        this.Placeholder && this.Placeholder.show();
      } else {
        this.Placeholder && this.Placeholder.hidden();
      }
    }
  }, {
    key: 'renderPlaceholder',
    value: function renderPlaceholder(type, separator, style) {
      var _this2 = this;

      var _props = this.props,
          placeholder = _props.placeholder,
          visibleIcon = _props.visibleIcon,
          iconAlign = _props.iconAlign,
          fileComponent = _props.fileComponent;
      var _state = this.state,
          value = _state.value,
          file = _state.file;

      if (fileComponent) {
        return _react2.default.createElement(_Placeholder2.default, {
          ref: function ref(c) {
            return _this2.Placeholder = c;
          },
          placeholder: placeholder,
          visibleIcon: visibleIcon,
          iconAlign: iconAlign,
          value: file,
          separator: separator,
          type: type,
          style: style,
          dataTestID: this.getSubDataTestId('placeholder')
        });
      }
      return _react2.default.createElement(_Placeholder2.default, {
        ref: function ref(c) {
          return _this2.Placeholder = c;
        },
        placeholder: placeholder,
        visibleIcon: visibleIcon,
        iconAlign: iconAlign,
        value: value,
        separator: separator,
        type: type,
        style: style,
        dataTestID: this.getSubDataTestId('placeholder')
      });
    }
  }, {
    key: 'renderIcon',
    value: function renderIcon(position) {
      var _this3 = this;

      var _props2 = this.props,
          iconAlign = _props2.iconAlign,
          visibleIcon = _props2.visibleIcon,
          iconCls = _props2.iconCls,
          icon = _props2.icon,
          iconLine = _props2.iconLine,
          iconType = _props2.iconType,
          tooltip = _props2.tooltip;

      if (iconAlign === position && visibleIcon) {
        return _react2.default.createElement(_IconComponent2.default, {
          ref: function ref(c) {
            return _this3.iconInput = c;
          },
          position: iconAlign,
          iconCls: iconCls,
          iconType: iconType,
          icon: icon,
          iconLine: iconLine,
          tooltip: tooltip,
          dataTestID: this.getSubDataTestId('icon')
        });
      }
      return null;
    }
  }, {
    key: 'renderButtonClear',
    value: function renderButtonClear() {
      var value = this.state.value;
      var isClearable = this.props.isClearable;

      if (!isClearable || value === undefined || value === null || value === "") {
        return null;
      }
      return _react2.default.createElement(_ButtonClear2.default, { onClick: this.onClear });
    }
  }, {
    key: 'boDauTiengViet',
    value: function boDauTiengViet(str) {
      if (!str) {
        return '';
      }
      str = _lodash2.default.lowerCase(str);
      str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a');
      str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e');
      str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i');
      str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o');
      str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u');
      str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y');
      str = str.replace(/đ/g, 'd');
      return str;
    }
  }, {
    key: 'getDataTestId',
    value: function getDataTestId() {
      var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'component';

      return this.props.dataTestID || this.dataTestID + '-' + prefix;
    }
  }, {
    key: 'getSubDataTestId',
    value: function getSubDataTestId() {
      var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      return this.getDataTestId() + '-' + prefix;
    }
  }, {
    key: 'renderIncreaseAndDecrease',
    value: function renderIncreaseAndDecrease() {
      return "";
    }
  }, {
    key: 'getCountryCode',
    value: function getCountryCode(input) {
      // Set default country code to US if no real country code is specified
      var hasDialOutCode = false;
      if (input.substr(0, 1) !== '+' && input.substr(0, 2) === '00') {
        input = input.replace(/^00+/, '+');
        hasDialOutCode = true;
      }

      var libphonenumber = require('libphonenumber-js');
      var AsYouType = libphonenumber.AsYouType;


      var defaultCountryCode = input.substr(0, 1) !== '+' ? 'US' : null;
      var asYouType = new AsYouType(defaultCountryCode);
      var formatted = asYouType.input(input);
      var countryCode = '';
      var withoutCountryCode = formatted;

      if (defaultCountryCode === 'US') {
        countryCode = '+1';
        formatted = '+1 ' + formatted;
      } else {
        var parts = formatted.split(' ');
        countryCode = parts.length > 1 ? parts.shift() : '';
        withoutCountryCode = parts.join(' ');
      }
      var dialOutCodes = countryCode.replace(/\+/g, '00');
      return {
        formatted: !hasDialOutCode ? formatted : dialOutCodes + ' ' + withoutCountryCode,
        withoutCountryCode: withoutCountryCode,
        countryCode: !hasDialOutCode ? countryCode : dialOutCodes
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          disabled = _props3.disabled,
          className = _props3.className,
          style = _props3.style,
          readOnly = _props3.readOnly,
          iconAlign = _props3.iconAlign,
          iconLine = _props3.iconLine;

      return _react2.default.createElement(
        'div',
        {
          'data-testid': this.getDataTestId(),
          className: (0, _classnames2.default)('body-wrap', '' + this.classNameDefault, className, { 'input-disabled': disabled, 'read-only': readOnly }, 'icon-align-' + iconAlign, { 'icon-visible-line': !iconLine }),
          style: style
        },
        this.renderCleavePhone(),
        this.renderIcon('before'),
        this.renderBody(),
        this.renderButtonClear('after'),
        this.renderIncreaseAndDecrease(),
        this.renderIcon('after'),
        this.renderPlaceholder()
      );
    }
  }]);
  return BaseComponent;
}(_react2.default.PureComponent);

exports.default = BaseComponent;